import { StationModel } from './station-model.model';

export class GroupModel {
  Id: string;
  Name: string;
  Group: string;
  Models: Array<StationModel>;
  SearchString: string;

  constructor() {
    this.Models = new Array<StationModel>();
  }

  public get allowsGroupEditing(): boolean {
    return this.Models.some((model) => model.AllowEditing) && this.Models.every((model) => !model.IsDisabled);
  }

  public buildSearchString() {
    this.SearchString = '';

    this.Models.forEach((model) => {
      this.SearchString += model.SearchString;
    });
  }
}
